module.exports = __webpack_public_path__ + "static/ux-design-mobile-d0058ca4483edf345337d18e483e96a6.jpg";